/**
 * Props that are passed to the child of the DialogTrigger when cloned to ensure correct behavior for the Dialog
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
